<app-profile-header></app-profile-header>
<section class="body-section">
    <div class="container">
        <main>
            <div class="bottom-container matches-table d-none">
                <div class="box transaction-box ">
                    <div class="not-found-section">
                        <div class="col-md-12 not-found-body  "><img src="assets/img/logo/not-found.gif" alt="">
                            <h4>Coming Soon!</h4>
                            <p>Exciting developments are on the horizon! Keep an eye out for an impending
                                announcement that will have you excited and anticipating what's to come. We can't
                                wait to tell you about this fantastic news. Keep a look out for additional updates,
                                because something fantastic is on the way!</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bottom-container matches-table pt-0 ">
                <div class="box transaction-box ">

                    <div class="header-container">
                        <h3 class="section-header">Matches</h3>
                    </div>
                    <div class="col-md-12 heading-button">
                        <button data-bs-toggle="collapse" data-bs-target="#compare-2"
                            class="accordion-toggle light-gery " [ngClass]="{'': upcomingstatus, 'rotate': !upcomingstatus}" 
                            (click)="upcomingMatch()">Upcoming <span class="icon"><i
                                    class='bx bx-chevron-down'></i></span>
                        </button>
                    </div>
                    <!-- <p-table></p-table> -->
                    <div class=" col-md-12 accordian-body collapse show" id="compare-2">
                        <div class="col-md-12">
                            <div class="compare-table-inner-div">
                                <div class="close-inner-icon">
                                    <button data-bs-toggle="collapse " data-bs-target="#compare-2"> <i
                                            class="pi pi-times"></i></button>
                                </div>
                                <div class="finished-wrapper">
                                    <div class="not-found-section" *ngIf="totalupcommingmatchCount ==0">
                                        <div class="col-md-12 not-found-body">
                                            <img src="assets/img/logo/not-found.gif" alt="">
                                            <h4>Sorry! No Upcoming Matches </h4>


                                            <div class="col-md-12">
                                                <button (click)="clickTournament()">Let's Play Match</button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="matches-container" *ngIf="totalupcommingmatchCount != 0">
                                        <div class="rin-matches-card rin-card rin-card-bg-secondary rin-card-no-shadow rin-card-border"
                                            *ngFor="let upcommingMatch of upcommingmatchList">
                                            <div class="rin-card-title">
                                                <div class="match-title-container">
                                                    <div class="matches-header-left-side"><span
                                                            class="rin-type-label tournament">
                                                            tournament
                                                        </span>
                                                        <div class="rin-matches-name-wrapper"><i
                                                                class='bx bxs-tennis-ball'></i>
                                                            &nbsp;
                                                            <a (click)="onclickTournamentdetails(upcommingMatch.tournamentId)"
                                                                class="rin-matches-title underlined showCursor">
                                                                {{upcommingMatch.tournamentName}}
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="rin-card-header">
                                                <div class="match-header-content">
                                                    <div class="header-item"><i class='bx bx-calendar'></i>
                                                        <div class="rin-matches-max-width">
                                                            {{upcommingMatch.tournamentStartdate | date:'dd/MM/yyyy'}}
                                                        </div>
                                                    </div>
                                                    <div class="header-item"><i class='bx bx-flag'></i>
                                                        <div class="rin-matches-max-width">
                                                            {{upcommingMatch.matchTypeName}} |
                                                            {{upcommingMatch.ageGroupName}}
                                                        </div>

                                                    </div>
                                                </div>
                                                <hr class="upper-row">
                                            </div>
                                        </div>
                                        <div class="pagination-div col-md-12 d-flex justify-content-center">
                                            <p-paginator *ngIf="totalupcommingmatchCount != 0 " [rows]="4" #paginator
                                                [totalRecords]="totalupcommingmatchCount" pageLinkSize="3"
                                                (onPageChange)="loadUpcomingMatches($event)" [showPageLinks]="true"
                                                [rowsPerPageOptions]=" pagination"></p-paginator>
                                            <div *ngIf="totalupcommingmatchCount == 0">
                                                <span>
                                                    There is no Up Coming Match.
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 heading-button">
                        <button data-bs-toggle="collapse" data-bs-target="#compare-1" 
                            class="accordion-toggle light-gery " [ngClass]="{'': Historystatus, 'rotate': !Historystatus}" 
                            (click)="HistoryMatch()">History <span class="icon"><i
                                    class='bx bx-chevron-down'></i></span>
                        </button>
                    </div>
                    <div class=" col-md-12 accordian-body collapse show" id="compare-1">
                        <div class="col-md-12">
                            <div class="compare-table-inner-div">
                                <div class="close-inner-icon">
                                    <button data-bs-toggle="collapse " data-bs-target="#compare-1"> <i
                                            class="pi pi-times"></i></button>
                                </div>
                                <div class="not-found-section" *ngIf="totalpastMatchCount ==0">
                                    <div class="col-md-12 not-found-body">
                                        <img src="assets/img/logo/not-found.gif" alt="">
                                        <h4>Sorry! No Past Matches </h4>


                                        <div class="col-md-12">
                                            <button (click)="clickTournament()">Let's Play Match</button>
                                        </div>
                                    </div>
                                </div>
                                <div class="matches-container" #dt *ngIf="totalpastMatchCount != 0" [paginator]="true"
                                    [rows]="4" [rowsPerPageOptions]="paginationOption" [totalRecords]="totalRecords">
                                    <div class="rin-matches-card rin-card rin-card-bg-secondary rin-card-no-shadow rin-card-border"
                                        *ngFor="let pastMatch of pastMatchList">
                                        <div class="rin-card-title">
                                            <div class="match-title-container">
                                                <div class="matches-header-left-side"><span
                                                        class="rin-type-label tournament">
                                                        tournament
                                                    </span>
                                                    <div class="rin-matches-name-wrapper"><i
                                                            class='bx bxs-tennis-ball'></i>
                                                        &nbsp;
                                                        <a (click)="onclickTournamentdetails(pastMatch.tournamentId)"
                                                            class="rin-matches-title underlined showCursor">
                                                            {{pastMatch.tournamentName}}
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="rin-card-header">
                                            <div class="match-header-content">
                                                <div class="header-item"><i class='bx bx-calendar'></i>
                                                    <div class="rin-matches-max-width">
                                                        {{pastMatch.tournamentStartdate | date:'dd/MM/yyyy'}}
                                                    </div>
                                                </div>
                                                <div class="header-item"><i class='bx bx-flag'></i>
                                                    <div class="rin-matches-max-width">
                                                        {{pastMatch.matchTypeName}} | {{pastMatch.ageGroupName}}
                                                    </div>
                                                </div>
                                            </div> <!----> <!---->
                                            <hr class="upper-row">
                                        </div>
                                        <div class="rin-card-body">
                                            <div class="rin-matches-card-body-container">
                                                <div class="rin-matches-card-participant-names-container">
                                                    <span class="rin-match-participant-name-wrapper">
                                                        <img src="assets/img/players/flag2.png" alt="" class="flag">

                                                        {{this.loggedInUser?.userdata?.fullName}}   {{ pastMatch?.myParterName}} 

                                                    </span> <!----> <!----> <span *ngIf="pastMatch.playerName"
                                                        class="rin-match-participant-name-wrapper is-winner">
                                                        <img src="assets/img/players/flag2.png" alt="" class="flag">

                                                        {{pastMatch.playerName}}  {{ pastMatch?.opponentPartnerName}} 

                                                    </span>
                                                    <span *ngIf=" !pastMatch.playerName"
                                                        class="rin-match-participant-name-wrapper is-winner">
                                                        <img src="assets/img/players/flag2.png" alt="" class="flag">

                                                        Bye</span><!---->
                                                </div>
                                                <div class="rin-matches-score-container">
                                                    <div class="rin-matches-scorebox">
                                                        <span >{{pastMatch.player1val}}</span>
                                                        <span>{{pastMatch.player2val}}</span>
                                                    </div>
                                                </div> <!---->
                                            </div>
                                        </div>
                                    </div>
                                    <div class="pagination-div col-md-12 d-flex justify-content-center">
                                        <p-paginator *ngIf="totalupcommingmatchCount != 0 " [rows]="4" #paginator
                                            [totalRecords]="totalRecords" (onPageChange)="loadPastMatches($event)"
                                            [rowsPerPageOptions]=" pagination"></p-paginator>
                                        <div *ngIf="totalupcommingmatchCount == 0">
                                            <span>
                                                There is no Up Coming Match.
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</section>